﻿export type DistanceUnits = "NM" | "cable" | "km" | "m";

export const DistanceUnitsLabels: { [key in DistanceUnits]: string } = {
    m: "Meters",
    km: "Kilometers",
    cable: "Cables",
    NM: "Nautical miles"
}

export const DistanceUnitsShortLabel: { [key in DistanceUnits]: string } = {
    m: "m",
    km: "km",
    cable: "cb",
    NM: "NM"
}